<!-- 销售派单 -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">仓库</div>
                    <el-select v-model="searchData.SId" :loading="loading" class="search-item" size="small" filterable clearable remote @visible-change="getWarehouse">
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            </el-option
                        >
                    </el-select>
                    <div class="search-name">客户</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.Keyword"
                        remote
                        clearable
                        filterable
                        allow-create
                        @visible-change="searchCustom"
                        placeholder="客户名称/电话"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">销售单号</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="销售单号"></el-input>
                    <div class="search-name">拣货员</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.StaffId"
                        @visible-change="getSIdList"
                        clearable
                        remote
                        filterable
                        allow-create
                    >
                        <el-option v-for="item in staffList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">状态</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.State"
                        remote
                        filterable
                        allow-create
                    >
                        <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        size="small"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="handleChange"
                        :clearable="false"
                    ></el-date-picker>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary bottom-margin-left" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                </div>
            </div>
            <div class="table-ctn"> 
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border
                    :data="tableData"
                    ref="multipleTable"
                    style="width: 100%"
                    :row-key="getRowKeys"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column
                        prop="OrderCode"
                        label="销售单"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="EntpCusName"
                        label="客户"
                        width="180">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.EntpCusName" placement="top">
                                <div class="cus-ovi">
                                    {{ scope.row.EntpCusName }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="CallNum"
                        label="电话号码"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="OrderState"
                        label="当前状态"
                        width="80">
                        <template slot-scope="scope">
                            <div>
                                <span style="color: orange;" v-if="scope.row.OrderState != 21 && scope.row.OrderState != 35 && scope.row.OrderState != 36 && scope.row.OrderState != 37">
                                    待派单
                                </span>
                                <span style="color: rgb(24, 158, 235);" v-if="scope.row.OrderState == 21 || scope.row.OrderState == 36">
                                    正在拣货
                                </span>
                                <span style="color: red;" v-if="scope.row.OrderState == 35">
                                    已挂起
                                </span>
                                <span style="color: red;" v-if="scope.row.OrderState == 37">
                                    正在验货
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ShipTypeName"
                        label="发货方式"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="LogisticsName"
                        label="物流公司"
                        width="180">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.LogisticsName" placement="top">
                                <div class="cus-ovi">
                                    {{ scope.row.LogisticsName }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="SName"
                        label="指定出仓仓库"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="GoodsCount"
                        label="商品总数"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        prop="NotOutCOunt"
                        label="未出仓数"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        prop="OutCount"
                        label="已出仓数"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        prop="StaffName"
                        label="当前拣货员"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="ConfirmTime"
                        label="提交时间"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        label="创建时间"
                        width="180">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn" v-if="scope.row.OrderState != 31 && scope.row.OrderState != 37">
                                <el-button
                                    v-if="permission.buttonPause && scope.row.OrderState == 21 || scope.row.OrderState != 35"
                                    title="挂起"
                                    size="mini"
                                    type="text"
                                    @click="setOrderStateOrPicker(1, scope.row)"
                                    style="color: red;"
                                    >{{ permission.buttonPause }}</el-button
                                >
                                <el-button
                                    v-if="permission.assignPicker"
                                    title="指定拣货员"
                                    size="mini"
                                    type="text"
                                    @click="setAssignPicker(scope.row)"
                                    >{{ permission.assignPicker }}</el-button
                                >
                                <el-button
                                    v-if="permission.buttonCancelPause && scope.row.OrderState == 35"
                                    title="取消挂起"
                                    size="mini"
                                    type="text"
                                    @click="setOrderStateOrPicker(2,scope.row)"
                                    style="color: orange;"
                                    >{{ permission.buttonCancelPause }}</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
                <!--分页控件加if条件是因为，我们返回当前页面取得总条数totalNum的之前，element-ui的分页组件已经在页面加载完毕，
                当时的totalNum绑定的是data里面初始化的数据0，所以当总条数为0的时候，分页组件的页码默认为1。并且当totalNum在created生命周期里取得数据后
        ，分页组件也不会刷新。所以这就导致， 页面内容正确，但是页码高亮依旧是第一页。而且current-page要添加sync修饰符-->
            </div>
            <el-dialog :close-on-click-modal="false" title="指定拣货员" :visible.sync="assignPicker" width="300px">
                <div class="dialog-content" v-if="assignPicker">
                    <el-select v-model="staffId" placeholder="请选择">
                        <el-option v-for="item in staffList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="assignPicker = false">取 消</el-button>
                        <el-button type="primary" @click="setOrderStateOrPicker(0)">确 定</el-button>
                    </span>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    props: ['type'],
    data() {
        return {
            loading: false,
            searchData: {
                Keyword: '',
                SId: '',
                OrderCode: '',
                StaffId:'',
                State:0,
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            dateTimes:[],
            WarehouseList: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }, 
            stateList:[{
                value:0,
                label:"全部",
            },{
                value:1,
                label:"待派单",
            },{
                value:21,
                label:"正在拣货",
            },{
                value:35,
                label:"挂起",
            },{
                value:37,
                label:"待验货",
            }],
            staffList:[],
            staffId:'',
            staffName:'',
            selectDate : '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                ],
                onPick: ({maxDate, minDate}) => {
                    this.selectDate = minDate.getTime();
                    if (maxDate) {
                    this.selectDate = ''
                    }
                },
                disabledDate: (time) => {
                    if (this.selectDate !== '') {
                    const one = 30 * 24 * 3600 * 1000;
                    const minTime = this.selectDate - one;
                    const maxTime = this.selectDate + one;
                    return time.getTime() < minTime || time.getTime() > maxTime
                    }
                }
            },
            assignPicker:false,//指派拣货员的弹窗
            keyData:[],//存储当前点击列的数值
        };
    },
    watch: {
        staffId(newVal, oldVal) {
            let arr = this.staffList;
            let index = arr.findIndex(x=>x.EmployeeId == newVal);
            if(index > 0)
                this.staffName = this.staffList[index].EmployeeName;
        },  
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1+1, 0);
        this.dateTimes.push(this.msToDate(date1));
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(this.msToDate(date2));
        this.searchData.StartDate = this.msToDate(date2);
        this.searchData.EndDate = this.msToDate(date1);
    },
    mounted() {
        let that = this;
        that.getTableData();
        that.$util.setEnterEvent(that, that.$route.fullPath);
        that.permission = that.$util.getPermission('SaleOrderAssign');
    },
    methods: {
        handleSearch() {
            this.getTableData();
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusOId;
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0] + ' 00:00:00';
                this.searchData.EndDate = val[1] + ' 23:59:59';
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        setAssignPicker(row){
            this.getSIdList();
            if(row.StaffId){//页面的员工列表是只有正常状态的，如果
                let arr = this.staffList;
                let index = arr.findIndex(x=>x.EmployeeId == row.StaffId);
                if(index > -1){
                    this.staffId = row.StaffId;
                }else{
                    this.staffList.push({EmployeeId:row.StaffId,EmployeeName :row.StaffName});
                    this.staffId = row.StaffId;
                }
                this.keyData = row;
                this.assignPicker = true;
            }else{
                this.staffId = '';
                this.keyData = row;
                this.assignPicker = true;
            }
        },
        setOrderStateOrPicker(type,data){//设置订单是否挂起配送等状态或指定拣货员
            var that = this;
            let Id = "";
            let staffId = "";
            let staffName = "";
            if(type == 0){
                if(!that.staffId){
                    that.$util.successMsg("请选择拣货员");
                    that.loading = false;
                    return false;
                }
                Id = that.keyData.Id
                staffId = that.staffId;
                staffName = that.staffName;
            }else if(type == 1){
                if(!data.StaffId){
                    staffId = '';
                }
                if(!data.StaffName){
                    staffName = '';
                }
                Id = data.Id;

            }else if(type == 2){
                Id = data.Id;
                staffId = data.staffId;
                staffName = data.staffName;
            }
            that.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/SetSaleOrderPicker?OrderId='+Id+'&StaffId='+staffId+'&StaffName='+staffName+'&Type='+type,
                })
                .then(res => {
                    if(res.errcode == 0){
                        that.$util.successMsg(res.errmsg);
                        that.getTableData();
                    }
                    that.assignPicker = false;
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerNoAuth(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        resetSearch() {
            this.searchData = {
                Keyword: '',
                SId: '',
                OrderCode: '',
                StaffId:'',
                State:0,
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            this.dateTimes = [];
            this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            let that = this;
            that.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetNotDeliverSaleOrderList',
                    data: that.searchData,
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        getWarehouse() {
            if (this.WarehouseList.length == 0) {
                this.$util.getWarehouse(0).then(data => {
                    this.WarehouseList = data;
                });
            }
        },
        getSIdList() {
            this.$util.
                axiosGet({
                url: '/api/EntpInfoManagement/GetEntpNoIsDisableStaffList',
                })
                .then(res => {
                    if (res.data) {
                        this.staffList = res.data;
                    }
                })
                .catch(() => {});
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property == 'OrderState' || column.property == 'CallNum' || column.property == 'StaffName'|| column.property == 'LogisticsName') {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        msToDate (msec) {
            let datetime = new Date(msec);
            let year = datetime.getFullYear();
            let month = datetime.getMonth();
            let date = datetime.getDate();
            let hour = datetime.getHours();
            let minute = datetime.getMinutes();
            let second = datetime.getSeconds();
        
            let result = year + 
                        '-' + 
                        ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) + 
                        '-' + 
                        ((date + 1) < 10 ? '0' + date : date);
    
        
            return result;
        }
    }
};
</script>
<style lang="less" scoped>
.el-range-editor--small.el-input__inner{
    margin-bottom: 10px;
}
.bottom-margin-left{
    margin-left: 5px;
}
.dialog-content{
    height: 125px;
}
.dialog-footer{
    margin-top: 20px;
    float: right;
}
.cus-ovi{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
}
</style>
